module.exports = __webpack_public_path__ + "static/media/bonusGame_2.46e26e34.mp3";